export const generateReplacementStringFromObj = ({ name, width: w, height: h }) => (
  `${(w < h ? `${w || '-'}×${h || '-'}` : `${h || '-'}×${w || '-'}`)} ${name || '-'}`
);
